module.exports = __webpack_public_path__ + "static/roots-botanical-coloring-page-d21de54ebe55eff6ea40883c414c061c.pdf";